package com.nonopn.skywatcher.common.app.pages.map.model.forecast

data class GraphValue(
    val float: Float,
    val type: GraphColorsType
)

enum class GraphColorsType {
    Rain,
    Humidity
}